import isNil from 'lodash/isNil';

import {
    LC_PRODUCT_STATE_LIVE_IN_COLLECTION,
    LC_PRODUCT_STATE_LIVE_INACTIVE,
    LC_PRODUCT_STATE_NEW,
    LC_PRODUCT_STATE_PROCESSING,
    LC_PRODUCT_STATE_UPDATED
} from '../../yourborrowbox/localcontent/product/LCStatusIndicator/StatusIndicatorStepState';
type StateListOptions =
    | typeof LC_PRODUCT_STATE_NEW
    | typeof LC_PRODUCT_STATE_UPDATED
    | typeof LC_PRODUCT_STATE_PROCESSING
    | typeof LC_PRODUCT_STATE_LIVE_IN_COLLECTION
    | typeof LC_PRODUCT_STATE_LIVE_INACTIVE;

export type StateList = Array<StateListOptions>;

export function extractStateObject(stateList: string[]): {
    newState: boolean;
    updated: boolean;
    processing: boolean;
    liveCollection: boolean;
    inactive: boolean;
} {
    if (isNil(stateList) || stateList.length === 0) {
        return { newState: false, updated: false, processing: false, liveCollection: false, inactive: false };
    }

    const processing = stateList.includes(LC_PRODUCT_STATE_PROCESSING);
    const newState = stateList.includes(LC_PRODUCT_STATE_NEW);
    const updated = stateList.includes(LC_PRODUCT_STATE_UPDATED);
    const liveCollection = stateList.includes(LC_PRODUCT_STATE_LIVE_IN_COLLECTION);
    const inactive = stateList.includes(LC_PRODUCT_STATE_LIVE_INACTIVE);

    return { newState, updated, processing, liveCollection, inactive };
}
